import { render, staticRenderFns } from "./ss-circles-comment.vue?vue&type=template&id=cc393c2a&scoped=true&"
import script from "./ss-circles-comment.vue?vue&type=script&lang=js&"
export * from "./ss-circles-comment.vue?vue&type=script&lang=js&"
import style0 from "./ss-circles-comment.vue?vue&type=style&index=0&id=cc393c2a&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc393c2a",
  null
  
)

export default component.exports